import styled from "styled-components";
import { colors } from "styles/theme";

export const SellerCatalogueWrapper = styled.div`
  .cta-credits span {
    color: ${colors.green};
    font-weight: bold;
  }
`;
